// Загрузка данных экрана со стандартными состояниями ux/11 §4: ST-LOADING (таймаут 10 с → ST-ERROR),
// ST-ERROR с «Повторить» (данные из кэша остаются), ST-OFFLINE.
import { useEffect, useState } from 'preact/hooks';
import { ApiCallError } from '../net/api-client.js';

export interface Load<T> { data: T | null; loading: boolean; error: string | null; offline: boolean; reload: () => void }

export const LOAD_TIMEOUT_MS = 10_000;

export function useLoad<T>(fn: () => Promise<T>, o: { cached?: T | null; onData?: (d: T) => void } = {}): Load<T> {
  const [data, setData] = useState<T | null>(o.cached ?? null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [offline, setOffline] = useState(false);
  const [n, setN] = useState(0);
  useEffect(() => {
    let alive = true;
    setLoading(true);
    setError(null);
    const to = setTimeout(() => { if (alive) { setLoading(false); setError('TIMEOUT'); } }, LOAD_TIMEOUT_MS);
    fn().then((d) => {
      if (!alive) return;
      setData(d); setOffline(false); o.onData?.(d);
    }).catch((e: unknown) => {
      if (!alive) return;
      const code = e instanceof ApiCallError ? e.code : 'INTERNAL';
      setOffline(code === 'NETWORK' || code === 'TIMEOUT');
      setError(code);
    }).finally(() => { clearTimeout(to); if (alive) setLoading(false); });
    return () => { alive = false; clearTimeout(to); };
  }, [n]);
  return { data, loading, error, offline, reload: () => setN((x) => x + 1) };
}
